const readURLArguments = query => (!query
  ? {}
  : (/^[?#]/.test(query) ? query.slice(1) : query)
    .split('&')
    .reduce((parameters, parameter) => {
      const [key, value] = parameter.split('=')
      return {
        ...parameters,
        [key]: value ? decodeURIComponent(value.replace(/\+/g, ' ')) : ''
      }
    }, {})
)

const cleanURL = () =>
  window.history.replaceState(null, null, window.location.pathname)

export {readURLArguments, cleanURL}

